export const COMMODITY_CATEGORY_GET = 'COMMODITY_CATEGORY_GET';
export const COMMODITY_CATEGORY_GET_SUCCESS = 'COMMODITY_CATEGORY_GET_SUCCESS';
export const COMMODITY_CATEGORY_GET_ERROR = 'COMMODITY_CATEGORY_GET_ERROR';

export const COMMODITY_CATEGORY_POST = 'COMMODITY_CATEGORY_POST';
export const COMMODITY_CATEGORY_POST_SUCCESS = 'COMMODITY_CATEGORY_POST_SUCCESS';
export const COMMODITY_CATEGORY_POST_ERROR = 'COMMODITY_CATEGORY_POST_ERROR';

export const COMMODITY_CATEGORY_UPDATE = 'COMMODITY_CATEGORY_UPDATE';
export const COMMODITY_CATEGORY_UPDATE_SUCCESS = 'COMMODITY_CATEGORY_UPDATE_SUCCESS';
export const COMMODITY_CATEGORY_UPDATE_ERROR = 'COMMODITY_CATEGORY_UPDATE_ERROR';

export const COMMODITY_CATEGORY_DELETE = 'COMMODITY_CATEGORY_DELETE';
export const COMMODITY_CATEGORY_DELETE_SUCCESS = 'COMMODITY_CATEGORY_DELETE_SUCCESS';
export const COMMODITY_CATEGORY_DELETE_ERROR = 'COMMODITY_CATEGORY_DELETE_ERROR';

export const COMMODITY_CATEGORY_STATE_EMPTY = 'COMMODITY_CATEGORY_STATE_EMPTY';
